export let TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["DEFAULT"] = "default";
  TYPE_OPTIONS["BASIC"] = "basic";
  TYPE_OPTIONS["MEDIUM"] = "medium";
  TYPE_OPTIONS["TOP"] = "top";
  return TYPE_OPTIONS;
}({});